import { AxiosError } from 'axios';

import { NOTES_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { NoteAttachment } from '@/types/note.type';
import { ApiResponse } from '@/types/response.type';

const getNotesAttachments = async (
  zee_id: string
): Promise<ApiResponse<NoteAttachment[]>> => {
  try {
    const response = await apiManager.get(
      `${NOTES_API_URL}/documents/${zee_id}`
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getNotesAttachments;
